import { render, staticRenderFns } from "./NewPayrun.vue?vue&type=template&id=22f90f23"
import script from "./NewPayrun.vue?vue&type=script&lang=js"
export * from "./NewPayrun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports